import { Image } from '@nettbureau/featured-core';
import { Fragment } from 'react';

export interface HeadForLocationProps {
  name: string;
}

export function HeadForLocation(props: HeadForLocationProps) {
  const { name } = props;

  const schema = {
    '@context': 'http://schema.org',
    '@type': 'City',
    ...addToSchema('name', name),
  };

  return (
    <Fragment>
      <Schema schema={JSON.stringify(schema)} />
      <meta property="og:title" content={name} />
      <meta property="og:type" content="website" />
    </Fragment>
  );
}

export interface HeadForOrganizationProps {
  name: string;
  website: string | null;
  address: string | null;
  email: string | null;
  phone: string | null;
  postcode: string | null;
  topImage: Image | null;
  logo: Image | null;
}

export function HeadForOrganization(props: HeadForOrganizationProps) {
  const { name, website, topImage, logo, email, phone, address, postcode } =
    props;

  const schema = {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name: name,
    ...addToSchema('url', website),
    ...addToSchema('email', email),
    ...addToSchema('telephone', phone),
    address: {
      '@type': 'PostalAddress',
      ...addToSchema('streetAddress', address),
      ...addToSchema('postalCode', postcode),
    },
    ...(logo !== null
      ? {
          logo: logo.url,
        }
      : {}),
  };

  return (
    <Fragment>
      <Schema schema={JSON.stringify(schema)} />
      <meta property="og:title" content={name} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={website ?? ''} />
      {topImage !== null && <meta property="og:image" content={topImage.url} />}
    </Fragment>
  );
}

interface SchemaProps {
  schema: string;
}

function Schema({ schema }: SchemaProps) {
  return (
    <script
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      type="application/json+ld"
    />
  );
}

function addToSchema(key: string, value: string | null) {
  return value !== null
    ? {
        [key]: value,
      }
    : {};
}
